'use client'
import { PrismicImage, PrismicLink, PrismicRichText } from "@prismicio/react"
import { useEffect, useState } from "react";
import { usePathname } from 'next/navigation'
import Link from "next/link";
import Image from "next/image";
import { Player } from "@lottiefiles/react-lottie-player";


const CHeaderMobile = ({ header }) => {
  const path = usePathname()
  const main_menu_items = header.data.menu_items;
  const [isShown, setIsShown] = useState(null);
  const [selectedSubHeader, setSelectedSubHeader] = useState(null);
  const [selectedSubHeaderLabel, setSelectedSubHeaderLabel] = useState('');
  const [selectedSubSubHeader, setSelectedSubSubHeader] = useState(null);
  const [selectedSubSubHeaderLabel, setSelectedSubSubHeaderLabel] = useState('');



  function reset() {
    setSelectedSubHeader(null);
    setSelectedSubSubHeader(null);
    setSelectedSubHeaderLabel('');
    setSelectedSubSubHeaderLabel('');
  }

  function selectSubHeader(index) {
    setSelectedSubHeader(main_menu_items[index].menu_item.data.menu_items);
    setSelectedSubHeaderLabel(main_menu_items[index].cta_label);
  }
  function selectSubSubHeader(index) {
    setSelectedSubSubHeader(selectedSubHeader[index].menu_item.data.menu_items);
    setSelectedSubSubHeaderLabel(selectedSubHeader[index].cta_label);
  }
  function toggleMenuMobile() {
    setIsShown(!isShown);
  }

  return <div className="lg:hidden w-full flex flex-col">
    <div
      className="bg-white border-2 border-dark-grey rounded-[33px] w-full flex justify-between items-center relative z-50">
      <div className="px-5">
        <Link href="/" aria-label="Main" role="navigation" className="flex items-center">
          <div id="home-logo" className="w-[123px] h-[18px]">
            <Player
              id="home-asset"
              mode="normal"
              src="/anim/Berkail-logo.json">
            </Player>
          </div>
        </Link>
      </div>
      {
        !header.data.lp_text.length > 0 && <div className="flex items-center">
          <div
            className="border-x-2 border-dark-grey bg-light-pink hover:bg-dark-pink p-2.5 md:p-4 button-text-menu text-center">
            <p>
              <PrismicLink field={header.data.cta_page} className="no-underline cta_form">{header.data.cta_label}</PrismicLink>
            </p>
          </div>
          <div className="pl-4 pr-5">
            <div className="flex items-center" onClick={toggleMenuMobile}>
              <span className="">
                <Image width={27} height={22} alt="logo" src='/svg/burger-menu.svg' />
              </span>
            </div>
          </div>
        </div>
      }
      {
        header.data.lp_text.length > 0 && <div className="py-3 pr-6 text-right">
          <PrismicRichText field={header.data.lp_text} components={{
            paragraph: ({ children }) => <p className="fil-text-header">{children}</p>
          }} />
        </div>
      }

    </div>
    {
      isShown &&
      <div className="menu-mobile-content w-screen fixed z-20 h-menu-mobile top-0 left-0 p-4">
        <div className="flex flex-col justify-between bg-white border-x-2 border-b-2 border-dark-grey mt-[28px] h-full">
          <div>
            <div className="flex justify-center pt-6 md:pt-20 pb-[40px] menu-items-mobile">
              {/* <a href="/" className="hidden pr-6">FR</a>
              <a href="/" className="hidden pr-6">EN</a> */}
            </div>
            {
              selectedSubHeader === null && <ul className="flex flex-col menu-items-mobile w-full">
                {
                  main_menu_items.map(({ menu_item, cta_label }, i, array) => {
                    // si il n'y a pas d'enfant alors...
                    if (menu_item.type === "page") {
                      return <li key={i} className={`w-full ${i < array.length - 1 ? 'border-t-2' : 'border-y-2'} border-dark-grey px-4 py-[18px]`}>
                        <PrismicLink field={menu_item}
                          className={path.includes(menu_item.uid) ? 'font-semibold' : ''}>
                          {cta_label}
                        </PrismicLink>
                      </li>
                    }
                    // si il y a des enfants alors...l
                    if (menu_item.type === "menu_item") {
                      return <li
                        key={i}
                        onClick={() => selectSubHeader(i)}
                        className={`w-full border-dark-grey px-4 py-[18px] ${i < array.length - 1 ? 'border-t-2' : 'border-y-2'}`}>
                        <div className="flex flex-row justify-between w-full items-baseline toggle-btn-menu">
                          <div>{cta_label}</div>
                          <div className="mt-2 lg:hidden -rotate-90 lg:rotate-0">
                            <div className="spin_arrow ">
                              <img src="/svg/arrow-faq.svg"  loading="lazy"/>
                            </div>
                          </div>
                        </div>
                        <div className="hidden">
                          <ul className="opacity-70 text-dark-grey ml-10">
                            {
                              menu_item.data.menu_items.map(({ menu_item, cta_label }, i) => {
                                return <li key={i} className="submenu pt-3.5 block">
                                  <PrismicLink field={menu_item}
                                    className={path.includes(menu_item.uid) ? 'font-semibold' : ''}>
                                    {cta_label}
                                  </PrismicLink>
                                </li>
                              })}
                          </ul>
                        </div>
                      </li>
                    }
                  })
                }
              </ul>
            }
            {
              selectedSubHeader !== null && <div>
                {selectedSubSubHeader === null && <ul className="flex flex-col menu-items-mobile w-full bg-light-beige border-dark-grey border-y-2 p-4">
                  <p className="text-xs flex flex-row items-center mb-2">
                    <span className="underline" onClick={reset}>Accueil</span>
                    <img className="-rotate-90 inline h-[6px] px-1" src="/svg/arrow-faq.svg"  loading="lazy"/>
                    <strong>{selectedSubHeaderLabel}</strong>
                  </p>
                  {
                    selectedSubHeader.map(({ menu_item, cta_label }, i, array) => {
                      // si il n'y a pas d'enfant alors...
                      if (menu_item.type === "page" || menu_item.type === "home" || menu_item.type === "article" || menu_item.type === "project") {
                        return <li key={i} className={`w-full px-2 md:px-4 py-3 md:py-[18px]`}>
                          <PrismicLink field={menu_item}
                            className={path.includes(menu_item.uid) ? 'font-semibold !text-lg' : '!text-lg'}>
                            {cta_label}
                          </PrismicLink>
                        </li>
                      }
                      // si il y a des enfants alors...l
                      if (menu_item.type === "menu_item") {
                        return <li
                          key={i}
                          onClick={() => selectSubSubHeader(i)}
                          className={`w-full px-2 md:px-4 py-3 md:py-[18px]`}>
                          <div className="flex flex-row justify-between items-baseline w-full toggle-btn-menu">
                            <div className="text-lg">{cta_label}</div>
                            <div className="mt-2 lg:hidden">
                              <div className="spin_arrow">
                                <img className="-rotate-90  w-full h-auto " src="/svg/arrow-faq.svg" loading="lazy"/>
                              </div>
                            </div>
                          </div>
                          <div className="hidden">
                            <ul className="opacity-70 text-dark-grey ml-10">
                              {
                                menu_item.data.menu_items.map(({ menu_item, cta_label }, i) => {
                                  return <li key={i} className="submenu pt-3.5 block">
                                    <PrismicLink field={menu_item}
                                      className={path.includes(menu_item.uid) ? 'font-semibold' : ''}>
                                      {cta_label}
                                    </PrismicLink>
                                  </li>
                                })}
                            </ul>
                          </div>
                        </li>
                      }
                    })
                  }
                </ul>
                }
                {selectedSubSubHeader !== null && <ul className="flex flex-col menu-items-mobile w-full bg-light-beige border-dark-grey border-y-2 p-4 text-ellipsis overflow-hidden">
                  <p className="text-xs flex flex-row items-center mb-2">
                    <span className="underline" onClick={reset}>Accueil</span>
                    <img className="-rotate-90 inline h-[6px] px-1" src="/svg/arrow-faq.svg"  loading="lazy"/>
                    <span className="underline" onClick={() => setSelectedSubSubHeader(null)}>{selectedSubHeaderLabel}</span>
                    <img className="-rotate-90 inline h-[6px] px-1" src="/svg/arrow-faq.svg"  loading="lazy"/>
                    <strong>{selectedSubSubHeaderLabel}</strong>
                  </p>

                  {
                    selectedSubSubHeader.map(({ menu_item, cta_label }, i, array) => {
                      // si il n'y a pas d'enfant alors...
                      if (menu_item.type === "page" || menu_item.type === "home" || menu_item.type === "article" || menu_item.type === "project") {
                        return <li key={i} className={`w-full px-4 py-2`}>
                          <PrismicLink field={menu_item}
                            className={path.includes(menu_item.uid) ? 'font-semibold !text-lg' : '!text-lg'}>
                            {cta_label}
                          </PrismicLink>
                        </li>
                      }
                    })
                  }
                </ul>
                }
              </div>
            }
          </div>
          <div>
            <div className="px-12 flex flex-col justify-center">
              <div className="mb-7 w-full md:max-w-[300px] mx-auto">
                <PrismicLink field={header.data.cta_page} className="button button-text-menu button-menu uppercase block text-center bg-pink cta_form">
                  {header.data.cta_label}
                </PrismicLink>
              </div>
              <div className="w-full md:max-w-[300px] mx-auto">
                <a href={`tel:${header.data.tel}`}
                  className="button button-text-menu button-menu uppercase block text-center phone_btn">
                  {header.data.tel}</a>
              </div>
            </div>
          </div>
          <div className="flex border-t-2 border-dark-grey">
            {
              header.data.some.map((rsItem, i, array) => {
                return <div key={i} className={`w-1/6 ${i < array.length < 6 ? 'border-r-2' : ''} border-dark-grey `}>
                  <PrismicLink field={rsItem.cta_page} target="rsItems.picto_link.target"
                    className="flex items-center justify-center social_btn">
                    <PrismicImage field={rsItem.picto} className="object-contain w-[60px] h-[60px]"  loading="lazy"/>
                  </PrismicLink>
                </div>
              })
            }
          </div>
        </div>
      </div>
    }

  </div >
}

const CHeaderDesktopSubMenu = ({ subHeader, path }) => {
  return <div className="bg-white py-4 border-2 border-dark-grey absolute absolute-x-center w-[90%] rounded-b-3xl">
    <ul className="flex flex-row justify-around">
      {
        subHeader.map(({ menu_item, cta_label }, i) => {
          if (menu_item.type === "page" || menu_item.type === "home" || menu_item.type === "article" || menu_item.type === "project")
            return <li key={i}><PrismicLink field={menu_item}
              className={path.includes(menu_item.uid) ? 'font-semibold' : ''}>
              {cta_label}
            </PrismicLink>
            </li>
          if (menu_item.type === "menu_item") {
            return <li key={i} className="pr-4 dropdown dropdown-menu-item">
              <div className="cursor-pointer flex flex-row items-center mb-4 text-[15px] ml-[5px]">
                {cta_label}
              </div>
              <ul className="flex flex-col gap-1">
                {
                  menu_item.data.menu_items.map(({ menu_item, cta_label }, i) => {
                    return <li key={i} className="flex flex-row mb-1">
                      <span className="-rotate-90">
                        <img src="/svg/submenu-arrow.svg" className="w-auto h-[15px]" alt="flèche" loading="lazy"/>
                      </span>
                      <PrismicLink key={i} field={menu_item}
                        className={path.includes(menu_item.uid) ? 'font-semibold !text-xs' : '!text-xs'}>
                        {cta_label}
                      </PrismicLink>
                    </li>
                  })
                }
              </ul>
            </li>
          }
        })
      }
    </ul>
  </div>
}

const CHeaderDesktop = ({ header, subcat }) => {
  const path = usePathname()
  const main_menu_items = header.data.menu_items;
  const [selectedSubHeader, setSelectedSubHeader] = useState(null);


  function selectSubHeader(index) {
    setSelectedSubHeader(main_menu_items[index].menu_item.data.menu_items);
  }
  function reset() {
    setSelectedSubHeader(null)
  }

  return <div className="hidden lg:block bg-white border-2 border-dark-grey rounded-[33px] w-full menu-desktop relative" onMouseLeave={() => reset()}>
    <div className="flex justify-between items-center pl-30px w-full">
      <div>
        <Link href="/" aria-label="main" role="navigation" className="flex items-center">
          <div id="home-logo-desk" className="w-[123px] ">
            <Player
              id="home-asset"
              mode="normal"
              hover
              src="/anim/Berkail-logo.json">
            </Player>
          </div>
        </Link>
      </div>
      <div className="flex xl:flex-1 items-center">
        <div className="flex xl:flex-1 flex-row items-center menu-item-text">
          <ul className="xl:flex xl:flex-1 xl:justify-between lg:px-10 m-auto max-w-[700px]">
            {
              main_menu_items.map(({ menu_item, cta_label }, i) => {
                // si il n'y a pas d'enfant alors...
                if (menu_item.type === "page") {
                  return <li key={i} className="pr-4">
                    <PrismicLink field={menu_item}
                      className={path.includes(menu_item.uid) ? 'font-semibold' : ''}>
                      {cta_label}</PrismicLink>
                  </li>
                }
                // si il y a des enfants alors...l
                if (menu_item.type === "menu_item") {
                  return <li key={i} className="pr-4 dropdown dropdown-menu-item cursor-pointer" onMouseEnter={() => selectSubHeader(i)}>
                    <div className={`cursor-pointer flex flex-row items-center ${menu_item.uid === subcat ? 'font-semibold' : ''}`}>
                      {cta_label}
                      <span className="ml-1">
                        <img src="/svg/submenu-arrow.svg" className="w-[15px] h-[15px]" alt="flèche" loading="lazy"/>
                      </span>
                    </div>
                  </li>
                }

              })
            }
          </ul>
        </div>
        {
          header.data.cta_label && <div className="pr-5">
            <PrismicLink field={header.data.cta_page} className="cta_form button button-text-menu button-menu bg-light-pink hover:bg-dark-pink">
              {header.data.cta_label}
            </PrismicLink>
          </div>
        }
        {
          header.data.tel && <div className="border-l-2 border-dark-grey py-3 px-4">
            <a href={`tel:${header.data.tel}`}
              className="phone_btn">{header.data.tel}</a>
          </div>
        }
        {
          header.data.lp_text.length > 0 && <div className="py-3 px-6 fil-text">
            <PrismicRichText field={header.data.lp_text} />
          </div>
        }
        <div className="pl-5 hidden">
          <span className="flex flex-row items-center dropdown">
            <p className="mr-1"> FR </p>
            <img src="/svg/submenu-arrow.svg" alt="flèche" className="w-[15px] h-[15px]" loading="lazy"/>
            <ul className="dropdown-menu hidden">
              <li>EN</li>
              <li>IT</li>
            </ul>
          </span>
        </div>
      </div>
    </div>
    {
      selectedSubHeader !== null && <CHeaderDesktopSubMenu subHeader={selectedSubHeader} path={path} subcat={subcat} />
    }
  </div >
}

const CHeader = ({ header, subcat }) => {
  return <header className="fixed w-screen py-5 lg:pb-0 px-4 lg:px-5 z-50">
    <CHeaderMobile header={header}></CHeaderMobile>
    <CHeaderDesktop header={header} subcat={subcat}></CHeaderDesktop>
  </header>
}

export default CHeader